export default {

  namespaced: true,

  state: () => ({

    activeNfeModel: 55,

    currentPage: 1,

    searchForm: {}

  }),

  mutations: {
    setSearchForm(state, data) {

    },

    setActiveNfeModel(state, data) {
      state.activeNfeModel = data
    },

    setCurrentPage(state, data) {
      state.currentPage = data
    }

  },

  actions: {

    async getInvoices({ dispatch, commit }, params) {

      let response = await axios.get('/erp/invoice/invoice', { params })

      return response.data

    },
    async getReport({ dispatch, commit }, params) {

      const data = await axios.get("/erp/invoice/report", { params: params });

      return data;
    },

  }
}
